export enum Alignment {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
    JUSTIFY = 'justify'
}

export enum Position {
    STANDARD = 'standard',
    TOP = 'top',
    RIGHT = 'right',
    BOTTOM = 'bottom',
    LEFT = 'left'
}

export enum BadgeAliment {
    TOP = 'top',
    MIDDLE = 'middle',
    BOTTOM = 'bottom'
}

export enum TableCellAlign {
    LEFT = 'left',
    RIGHT = 'right',
    CENTER = 'center'
}

export enum TableSeparator {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
    CELL = 'cell',
    NONE = 'none'
}
